import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import {
  ProductOrigin,
  ProductOriginExternalReference
} from '../../../interfaces/Producto/ProductOrigins'
import { YesNoBadge } from '../../../components/YesNoBadge'
import { renderAllRelations } from '../../ProductOrigin/Components'

export const getColumnsConfig = (): TableColumn<ProductOrigin>[] => [
  { key: 'name', title: 'Nombre Marca en WMS' },
  { key: 'origin', title: 'Origen del producto' },
  {
    key: 'orderOriginNames',
    title: 'Canal de Venta',
    width: 300,
    render: (value) =>
      renderAllRelations((value as string[] | undefined) || [], 'center')
  },
  {
    key: 'productOriginsExternalReferences',
    title: 'Referencia Externa',
    width: 300,
    render: (value) =>
      renderAllRelations(
        (value as ProductOriginExternalReference[] | undefined)?.map(
          (reference) => reference.name
        ) || [],
        'center'
      )
  },
  {
    key: 'isActive',
    title: 'Activo',
    render: (value) => <YesNoBadge value={value as boolean} />
  }
]
